module.exports = require('./helpers/bundle-url').getBundleURL('hstjT') + "language-solid.da5cc6fd.svg";